import React, { ReactElement, useReducer } from 'react';
import { createContext, useContext } from 'react';

/**
 * Exports the useLanguage() hook which can be used to retrieve the user's selected language,
 * or the browser default language if one is not set.
 * If the language is not supported, then 'en' is the default.
 * 
 * The useLanguage() hook relies on context provided by a parent <LanguageProvider> (see App.tsx)
 */


export const EN = "en"
export const FR = "fr"
export type SupportedLanguage = "en" | "fr";

const LOCAL_STORAGE_LANG_KEY = "language"
const LanguageContext = createContext<SupportedLanguage>(EN);
const LanguageDispatchContext = createContext<React.DispatchWithoutAction|undefined>(undefined);


interface LanguageProviderProps {
    children: ReactElement
}

const langReducer = (_: SupportedLanguage) => {
    let language = localStorage.getItem(LOCAL_STORAGE_LANG_KEY);
    if (!language || language.startsWith(FR)) {
        localStorage.setItem(LOCAL_STORAGE_LANG_KEY, EN);
        language = EN
    } else {
        localStorage.setItem(LOCAL_STORAGE_LANG_KEY, FR);
        language = FR
    }    
    return language as SupportedLanguage;
}

const getBrowserLanguage = (): SupportedLanguage => {
    let language = navigator.language
    console.log("navigator.language =", language);
    if (language && language.startsWith(FR)) {
        language = FR;
    } else {
        language = EN;
    }
    return language as SupportedLanguage;
}

export function LanguageProvider({ children }: LanguageProviderProps) {

    const [lang, setLang] = useReducer(langReducer, getBrowserLanguage(), (browserLanguage: SupportedLanguage) => {
        let language = localStorage.getItem(LOCAL_STORAGE_LANG_KEY);
        if (!language) {
            language = browserLanguage;
            localStorage.setItem(LOCAL_STORAGE_LANG_KEY, language);
        }
        return language as SupportedLanguage;
    });
    
    return (
        <LanguageContext.Provider value={lang}>
            <LanguageDispatchContext.Provider value={setLang}>
                { children }
            </LanguageDispatchContext.Provider>
        </LanguageContext.Provider>
    )
}


export function useLanguage(): SupportedLanguage | undefined {
    return useContext(LanguageContext);
}

export function useLanguageDispatch() {
    return useContext(LanguageDispatchContext);

}